export default {
  id: 94,
  title: 'Target #94 - Ripples',
  url: 'https://cssbattle.dev/play/94',
  colors: ['#0E2E2C', '#F3AC3C', '#998235'],
  solution:
    '<p><style>body{background:#0e2e2c}p{position:fixed;width:200;height:200;border-radius:50%;top:34;left:100;box-shadow:inset 0 0 0 6px #f3ac3c,inset 0 0 0 20px #0e2e2c,inset 0 0 0 28px #f3ac3c,inset 0 0 0 40px #0e2e2c,inset 0 0 0 50px #998235,inset 0 0 0 60px #0e2e2c,inset 0 0 0 72px #f3ac3c,inset 0 0 0 80px #0e2e2c,inset 0 0 0 100px #f3ac3c}</style>',
}
